import React,{useState} from 'react';
import Navbar1 from '../main/Layout/Navbar1';
import DefaultHeader from '../main/Layout/DefaultHeader';
import axios from 'axios';
function UpdateProfile(props) {
    const userId = props.match.params.userId;
    const [values,setValues] = useState({
		name:"",
		email:"",
        password:"",
		error:"",
		success:false
	});

	const {name,email,password,error,success} = values;

	const handleChange = name =>event=>{
		setValues({...values,error:false,[name]:event.target.value});
	};

     const clickSubmit =(event)=>{
		event.preventDefault();
		setValues({...values,error:false});
		const body ={
				name:name,
				email:email,
				password:password,
		}
		axios.put(`/user/${userId}`,body)
		.then(data=>{
			setValues({...values,name:"",email:"",password:"",error:"",success:true,})
		}).catch(err=>{
			setValues({...values,error:err.response.data.message,success:false})
		})

	}

    
    const showError=()=>(
        error&&(
        <div className="alert alert-danger">{error}</div>
        )
    )

    const showSuccess=()=>(
        success&&(<div className="alert alert-success">{name} updated success</div>)
    )

    const signUpForm = ()=>(
        <React.Fragment>
            <form>
            <div className="form-group input-group">
                <div className="input-group-prepend">
                    <span className="input-group-text"> <i className="fa fa-user"></i> </span>
                 </div>
                <input onChange={handleChange('name')} value={name} className="form-control" placeholder="Full name" type="text"/>
            </div> 
            <div className="form-group input-group">
                <div className="input-group-prepend">
                    <span className="input-group-text"> <i className="fa fa-envelope"></i> </span>
                 </div>
                <input onChange={handleChange('email')} value={email} className="form-control" placeholder="Email address" type="email"/>
            </div> 
            {/* <div className="form-group input-group">
                <div className="input-group-prepend">
                    <span className="input-group-text"> <i className="fa fa-phone"></i> </span>
                </div>
                <select className="custom-select" style={{"maxWidth": "120px"}}>
                    <option value="">+84</option>
                </select>
                <input className="form-control" placeholder="Phone number" type="text"/>
            </div> 
            <div className="form-group input-group">
                <div className="input-group-prepend">
                    <span className="input-group-text"> <i className="fa fa-building"></i> </span>
                </div>
                <select className="form-control">
                    <option > Select job type</option>
                    <option>Designer</option>
                    <option>Manager</option>
                    <option>Accaunting</option>
                </select>
            </div> */}
            <div className="form-group input-group">
                <div className="input-group-prepend">
                    <span className="input-group-text"> <i className="fa fa-lock"></i> </span>
                </div>
                <input onChange={handleChange('password')} value={password}  className="form-control" placeholder="Create password" type="password"/>
            </div>                                     
            <div className="form-group">
                <button onClick={clickSubmit} className="btn btn-primary btn-block"> Update Account  </button>
            </div>                                                          
        </form>
         </React.Fragment>
    )
    return (
        <React.Fragment>
        <Navbar1/>
        <DefaultHeader/>
        <div className="container-fluid" >
            <br/>  
            <div className="row justify-content-md-center ">
                <div className="col col-lg-6 col-md-6 col-xs-6">
            
                    <div  card>
                    <div className="card-body mx-auto col col-lg-9 " style={{"width":"500px"}}>
                        {showError()}
                        {showSuccess()}
                        {signUpForm()}
                        </div>
                    </div>
                </div>
            </div>
            <br/>  
        </div>
    </React.Fragment>
    )
}

export default UpdateProfile;